/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocationSubscription200Response
 */
export interface GetLocationSubscription200Response {
    /**
     * 
     * @type {string}
     * @memberof GetLocationSubscription200Response
     */
    plan: GetLocationSubscription200ResponsePlanEnum;
    /**
     * 
     * @type {string}
     * @memberof GetLocationSubscription200Response
     */
    status: GetLocationSubscription200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetLocationSubscription200Response
     */
    paymentFrequency: GetLocationSubscription200ResponsePaymentFrequencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof GetLocationSubscription200Response
     */
    nextBillingDate: Date;
}


/**
 * @export
 */
export const GetLocationSubscription200ResponsePlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type GetLocationSubscription200ResponsePlanEnum = typeof GetLocationSubscription200ResponsePlanEnum[keyof typeof GetLocationSubscription200ResponsePlanEnum];

/**
 * @export
 */
export const GetLocationSubscription200ResponseStatusEnum = {
    Live: 'live',
    Installation: 'installation',
    Trial: 'trial',
    GracePeriod: 'gracePeriod',
    Suspended: 'suspended',
    Cancelled: 'cancelled',
    NonRenewing: 'nonRenewing',
    Temporal: 'temporal',
    Demo: 'demo'
} as const;
export type GetLocationSubscription200ResponseStatusEnum = typeof GetLocationSubscription200ResponseStatusEnum[keyof typeof GetLocationSubscription200ResponseStatusEnum];

/**
 * @export
 */
export const GetLocationSubscription200ResponsePaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type GetLocationSubscription200ResponsePaymentFrequencyEnum = typeof GetLocationSubscription200ResponsePaymentFrequencyEnum[keyof typeof GetLocationSubscription200ResponsePaymentFrequencyEnum];


/**
 * Check if a given object implements the GetLocationSubscription200Response interface.
 */
export function instanceOfGetLocationSubscription200Response(value: object): value is GetLocationSubscription200Response {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    if (!('nextBillingDate' in value) || value['nextBillingDate'] === undefined) return false;
    return true;
}

export function GetLocationSubscription200ResponseFromJSON(json: any): GetLocationSubscription200Response {
    return GetLocationSubscription200ResponseFromJSONTyped(json, false);
}

export function GetLocationSubscription200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationSubscription200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'status': json['status'],
        'paymentFrequency': json['paymentFrequency'],
        'nextBillingDate': (new Date(json['nextBillingDate'])),
    };
}

export function GetLocationSubscription200ResponseToJSON(json: any): GetLocationSubscription200Response {
    return GetLocationSubscription200ResponseToJSONTyped(json, false);
}

export function GetLocationSubscription200ResponseToJSONTyped(value?: GetLocationSubscription200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'status': value['status'],
        'paymentFrequency': value['paymentFrequency'],
        'nextBillingDate': ((value['nextBillingDate']).toISOString()),
    };
}

